import { getToken } from '../../utils/tokens'
import { decodeJWT, isEmpty } from '@navinc/utils'

/**
 * Checks if the current session is expired by examining the JWT token
 * @returns {boolean} True if session is expired or token is invalid, false otherwise
 */
export const getIsSessionExpired = () => {
  const token = getToken()

  // If no token exists, session is considered expired
  if (!token) {
    return true
  }

  try {
    // Decode the token (browser-compatible)
    const decodedToken = decodeJWT(token)

    // If token couldn't be decoded or is empty, consider session expired
    if (isEmpty(decodedToken)) {
      return true
    }

    // Check if token has expired by comparing exp claim with current time
    const currentTime = Math.floor(Date.now() / 1000) // Current time in seconds
    if (decodedToken.exp && decodedToken.exp < currentTime) {
      return true
    }

    // Token exists, is valid, and not expired
    return false
  } catch (error) {
    // If any error occurs during decoding, consider session expired
    console.error('Error checking session expiration:', error)
    return true
  }
}
